export function getRowCardOrders(hasWater: boolean): {
  water: number,
  trends: number,
  efficiency: number
} {
  return {
    water: hasWater ? 0 : 1,
    trends: hasWater ? 1 : 0,
    efficiency: 2,
  };
}
